<div *ngIf="breadcrumbItems$ | async as breadcrumbItems">
     <p-breadcrumb [dt]="breadCrumb" [model]="breadcrumbItems">
          <ng-template pTemplate="separator">/</ng-template>
           <ng-template let-item pTemplate="item">
               <a [routerLink]="item.url" class="p-breadcrumb-item-link">
                    <span [ngClass]="[item.icon ? item.icon : '']" ></span>
                    {{item.label}}
               </a>
           </ng-template>
     </p-breadcrumb>
</div>